import { TableColumnsType } from 'antd';
import TableComponent from 'components/Table/TableComponent';
import dayjs from 'dayjs';
import usePagination from 'hooks/usePagination';
import Content from 'layouts/Content';
import { forwardRef, useImperativeHandle, useMemo } from 'react';
import { formatCurrency, generateUUID } from 'utils/constants/functions';
import { HocChangePagination } from 'utils/HocChangePagination';

interface ITableTransactionFrequencyProps {
  loading?: boolean;
  data: any;
  exportExcel?: (columns: any) => void;
}

const TableTransactionFrequency = (
  { data, loading, exportExcel }: ITableTransactionFrequencyProps,
  ref: any,
) => {
  const { page, page_size } = usePagination();

  const columns: TableColumnsType = useMemo(
    () => [
      {
        width: 50,
        title: 'STT',
        align: 'center',
        render: (_: any, __: any, index: number) =>
          index + 1 + page_size * (page - 1),
      },
      {
        width: 250,
        title: 'Tên khách hàng',
        dataIndex: 'customer_name',
      },
      {
        width: 160,
        title: 'Mã khách hàng',
        dataIndex: 'sap_customer_id',
      },
      {
        width: 160,
        title: 'Mã khách hàng (Cha)',
        dataIndex: 'main_customer_id',
      },
      {
        width: 150,
        title: 'Tỉnh thành',
        dataIndex: 'city_name',
      },
      {
        title: 'Hàng công',
        children: [
          {
            width: 160,
            title: 'Hạng thẻ',
            dataIndex: 'rank_name',
            render: (value: any) => value || '-',
          },
          {
            type: 'number',
            width: 160,
            title: 'TB SL món/hóa đơn',
            dataIndex: 'proc_product_quantity_per_order',
            align: 'right',
            render: (value: any) => (value ? value.toFixed(1) : '-'),
          },
          {
            type: 'number',
            currency: 'vi-VN',
            width: 160,
            title: 'TB DT công/hóa đơn',
            dataIndex: 'proc_total_dt',
            align: 'right',
            render: (value: any) =>
              value
                ? formatCurrency({
                    value,
                  })
                : '-',
          },
          {
            width: 200,
            title: 'Tần suất mua hàng/tháng',
            dataIndex: 'proc_frequency',
            render: (value: any) => value || '-',
          },
          {
            type: 'date',
            formatDate: 'DD/MM/YYYY',
            width: 220,
            title: 'Thời gian mua hàng gần nhất',
            dataIndex: 'proc_latest_order_date',
            render: (value: any) =>
              value ? dayjs(value).format('DD/MM/YYYY') : '-',
          },
        ],
      },
      {
        title: 'Hàng món',
        children: [
          {
            width: 160,
            title: 'Hạng thẻ',
            dataIndex: 'rank_name',
            render: (value: any) => value || '-',
          },
          {
            type: 'number',
            width: 160,
            title: 'TB SL món/hóa đơn',
            dataIndex: 'prod_product_quantity_per_order',
            align: 'right',
            render: (value: any) => (value ? value.toFixed(1) : '-'),
          },
          {
            type: 'number',
            currency: 'vi-VN',
            width: 160,
            title: 'TB DT công/hóa đơn',
            dataIndex: 'prod_total_dt',
            align: 'right',
            render: (value: any) =>
              value
                ? formatCurrency({
                    value,
                  })
                : '-',
          },
          {
            width: 200,
            title: 'Tần suất mua hàng/tháng',
            dataIndex: 'prod_frequency',
            render: (value: any) => value || '-',
          },
          {
            type: 'date',
            formatDate: 'DD/MM/YYYY',
            width: 220,
            title: 'Thời gian mua hàng gần nhất',
            dataIndex: 'prod_latest_order_date',
            render: (value: any) =>
              value ? dayjs(value).format('DD/MM/YYYY') : '-',
          },
        ],
      },
    ],
    [page, page_size],
  );

  useImperativeHandle(ref, () => ({
    handleExportExcel,
  }));

  const handleExportExcel = () => {
    exportExcel && exportExcel(columns);
  };

  return (
    <Content>
      <TableComponent
        scroll={{ x: 'max-content' }}
        columns={columns}
        dataSource={data.items}
        rowKey={(record) => record?.id || generateUUID()}
        loading={loading}
        pagination={{
          current: data.pageInfo?.currentPage,
          pageSize: data.pageInfo?.itemsPerPage,
          total: data.pageInfo?.totalItems,
          onChange: HocChangePagination(),
        }}
      />
    </Content>
  );
};

export default forwardRef(TableTransactionFrequency);
